<script setup>
import B2CContactPopup from 'components/home/B2CContactPopup.vue'
import { useGlobalStore } from 'src/composables/useGlobalStore'
import { useMeta } from 'quasar'
import SolutionsCTA from 'components/solutions/SolutionsCTA.vue'
import SolutionsHeader from 'components/solutions/SolutionsHeader.vue'
import SolutionsReference from 'components/solutions/SolutionsReference.vue'
import SolutionsSteps from 'components/solutions/SolutionsSteps.vue'
import SolutionsModels from 'components/solutions/SolutionsModels.vue'
import SolutionsBenefits from 'components/solutions/SolutionsBenefits.vue'
import { ref } from 'vue'
const { globalConfiguration } = useGlobalStore()

const contactVisible = ref(false)
if (globalConfiguration.value && globalConfiguration.value.pages && globalConfiguration.value.pages.solutions) {
  useMeta({
    title: globalConfiguration.value.pages.solutions.title,
    meta: {
      description: { name: 'description', content: globalConfiguration.value.pages.solutions.description },
      keywords: { name: 'keywords', content: globalConfiguration.value.pages.solutions.keyword },
      canonical: { rel: 'canonical', href: 'https://raumpioniere.ch/solutions' },
      'og:title': { property: 'og:title', content: globalConfiguration.value.pages.solutions.ogTitle ? globalConfiguration.value.pages.solutions.ogTitle : globalConfiguration.value.pages.solutions.title },
      'og:image': { property: 'og:image', content: globalConfiguration.value.pages.solutions.ogImage ? globalConfiguration.value.pages.solutions.ogImage : 'https://raumpioniere.ch/icons/favicon-128x128.png' },
      'og:url': { property: 'og:url', content: 'https://raumpioniere.ch/solutions' },
      'og:description': { property: 'og:description', content: globalConfiguration.value.pages.solutions.ogDescription ? globalConfiguration.value.pages.solutions.ogDescription : globalConfiguration.value.pages.solutions.description },
      'og:type': { property: 'og:type', content: globalConfiguration.value.pages.solutions.ogType ? globalConfiguration.value.pages.solutions.ogType : 'Solutions' },
      'og:locale': { property: 'og:locale', content: 'de_CH' }
    }
  })
}
</script>

<template lang="pug">
.solutions
  b2-c-contact-popup(v-model:visible="contactVisible" :always="true")
  .routerPageSize
    solutions-header
    solutions-steps
  solutions-models
  solutions-benefits(v-model:visible="contactVisible")
  solutions-reference
  .routerPageSize
    solutions-c-t-a(v-model:visible="contactVisible")
</template>

<style lang="sass">
.solutions
</style>
